"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
/**
 * [dateFormat 时间戳转时间]
 *
 * @param   {[type]}  type  [type 时间显示类型]
 * @param   {[type]}  date  [date 时间戳]
 *
 * @return  {[type]}        [return description]
 */
var dateFormat = exports.dateFormat = function dateFormat(type, date) {
	var date = new Date(date);
	var o = {
		"m+": date.getMonth() + 1, //月份   
		"d+": date.getDate(), //日   
		"h+": date.getHours(), //小时   
		"i+": date.getMinutes(), //分   
		"s+": date.getSeconds() //秒   
	};
	if (/(y+)/.test(type)) {
		type = type.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	};
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(type)) {
			type = type.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
		};
	}
	return type;
};
/**
* 将年月日转化成时间戳
* @param {String} time
*/
var yyMmDdToTime = exports.yyMmDdToTime = function yyMmDdToTime(time) {
	return new Date(time.replace(/-|\./g, '/')).getTime();
};
exports.default = {
	dateFormat: dateFormat,
	yyMmDdToTime: yyMmDdToTime
};